import { CampaignName } from 'src/common/enums/campaigns';

import { useActiveCampaign } from './use-active-campaign';

export const useCampaignCheck = (campaignNames: readonly CampaignName[] | readonly string[]) => {
  const { campaign } = useActiveCampaign();
  return campaignNames.includes(campaign?.name as CampaignName);
};
